import * as yup from 'yup';

export default yup.object({
    actor: yup.object({}).nullable()
});
